import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';

export const getStringValueFromAdjustment = (adjustment?: AloftPrice): string => {
  if (isUndefined(adjustment)) return '';

  const numeric = adjustment.roundToDollarLike().toNumericPrice();

  return numeric === 0 ? '-' : adjustment.roundToDollarLike().toString(true);
};
